import DiscountTable from 'components/receipt/commons/ListItemBox/DiscountTable'
import ItemTable from 'components/receipt/commons/ListItemBox/ItemTable'
import RewardRedemptionInfo from 'components/receipt/commons/ListItemBox/RewardRedemptionInfo'
import {rupiah} from 'utils/formatter'
import styles from './ListItemBox.css'

class ListItemBox extends React.Component {
  render () {
    let {paymentDetail} = this.props
    let {loyalty, promos} = paymentDetail
    // noinspection JSUnresolvedVariable
    if (paymentDetail.checkouts.length > 0) {
      return <div className={styles['list-item-box']}>
        <ItemTable checkouts={paymentDetail.checkouts} checkoutPriceFormatter={rupiah} promos={promos} />
        <DiscountTable discounts={paymentDetail.payment_discounts} />
        {loyalty && loyalty.redemption && loyalty.redemption.reward &&
        <RewardRedemptionInfo redeemReward={loyalty.redemption.reward} totalRedeemAmount={paymentDetail.total_redeem_amount} />}
      </div>
    } else {
      let items = []
      for (let keys = Object.keys(paymentDetail.checkouts), i = 0, end = keys.length; i < end; i++) {
        let salesType = keys[i]
        let item = null
        if ((Object.keys(paymentDetail.checkouts).length <= 1) && (salesType === '' || salesType === 'No Sales Type')) {
          item = (<div className={styles['list-item-box']}>
            <ItemTable checkouts={paymentDetail.checkouts[salesType]} checkoutPriceFormatter={rupiah} promos={promos} />
            <DiscountTable discounts={paymentDetail.payment_discounts} />
            {loyalty && loyalty.redemption && loyalty.redemption.reward &&
            <RewardRedemptionInfo redeemReward={loyalty.redemption.reward} totalRedeemAmount={paymentDetail.total_redeem_amount} />}
          </div>)
        } else {
          if (i !== end - 1) {
            item = (<div className={styles['list-item-box']}>
              <div className={styles['sales-type-title']}>
                {(salesType === '' || salesType === 'No Sales Type') ? 'No Sales Type' : salesType}
              </div>
              <ItemTable checkouts={paymentDetail.checkouts[salesType]} checkoutPriceFormatter={rupiah} promos={promos} />
            </div>)
          } else {
            item = (<div className={styles['list-item-box']}>
              <div className={styles['sales-type-title']}>
                {(salesType === '' || salesType === 'No Sales Type') ? 'No Sales Type' : salesType}
              </div>
              <ItemTable checkouts={paymentDetail.checkouts[salesType]} checkoutPriceFormatter={rupiah} promos={promos} />
              <DiscountTable discounts={paymentDetail.payment_discounts} />
              {loyalty && loyalty.redemption && loyalty.redemption.reward &&
              <RewardRedemptionInfo redeemReward={loyalty.redemption.reward} totalRedeemAmount={paymentDetail.total_redeem_amount} />}
            </div>)
          }
        }
        items.push(item)
      }
      return <div>
        {items}
      </div>
    }
  }
}

ListItemBox.propTypes = {
  paymentDetail: React.PropTypes.object
}

export default ListItemBox



// WEBPACK FOOTER //
// ./app/components/receipt/transactions/ListItemBox/ListItemBox.js